import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarDays, faCalendarPlus, faListCheck } from '@fortawesome/free-solid-svg-icons';
import { getGameColor, getPlatformColor } from '../data/objects/gameColor';
import { Product } from '../data/interfaces/Product';

interface FeaturedReleaseInfoProps {
    product: Product;
}

const FeaturedReleaseInfo: React.FC<FeaturedReleaseInfoProps> = ({ product }) => {

    const gameColor = getGameColor(product.game);

    return (
        <div className="card-body">
            <h5 className="card-text ubuntu-bold featured-pill">FEATURED RELEASE</h5>
            
            <h1 className="card-text display-5 kanit-regular">{product.title.toUpperCase()}</h1>
            <div className="d-flex align-items-center">
                <div
                    className="game-indicator"
                    style={{
                        backgroundColor: gameColor
                    }}
                ></div>
                <p className="card-text m-0 kanit-regular" style={{ color: 'gray' }}>{product.game}</p>
            </div>

            <p className="card-text lead my-3 ubuntu-regular">{product.description}</p>
            <div className="d-flex align-items-center my-3">
                {product.platforms.map((platform, index) => (
                    <span
                        key={index}
                        className="platform-pill"
                        style={{
                            backgroundColor: getPlatformColor(platform),
                        }}
                    >
                        {platform}
                    </span>
                ))}
            </div>

            <div className="version-info kanit-light-italic">
                <FontAwesomeIcon icon={faListCheck} />
                <span>Version {product.version}</span>
            </div>

            <div className="dates-info kanit-light-italic">
                <FontAwesomeIcon icon={faCalendarDays} />
                <span>Posted: {product.datePosted}</span>
            </div>

            {product.dateUpdated && (
                <div className="dates-info kanit-light-italic">
                    <FontAwesomeIcon icon={faCalendarPlus} />
                    <span>Updated: {product.dateUpdated}</span>
                </div>
            )}
        </div>
    );
};

export default FeaturedReleaseInfo;
